import { Directive, ElementRef, Renderer2, OnInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appAppendToBody]'
})
export class AppendToBodyDirective implements OnInit, OnDestroy {
  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    // Move the element to document.body so it's not clipped by parent transforms/overflow
    try {
      this.renderer.appendChild(document.body, this.el.nativeElement);
    } catch (e) {
      // noop - best-effort
    }
  }

  ngOnDestroy(): void {
    try {
      if (this.el?.nativeElement?.parentNode === document.body) {
        this.renderer.removeChild(document.body, this.el.nativeElement);
      }
    } catch (e) {
      // noop
    }
  }
}
